export default __webpack_public_path__ + "static/Theinhardt-Medium-Italic-subset-2c52ac1e1f50c41c5ec113bfbceb2906.woff2";